import React from 'react'
import { useNormalizedFilter } from '../useNormalizedFilter'

interface boldStringData {
  boldString: (str: string, substr: string) => HTMLElement
}

export const useBoldString = (): boldStringData => {
  const { removeAccents } = useNormalizedFilter()

  const boldString = (str, substr) => {
    if (substr) {
      const normalizedStr = removeAccents(str)
      const normalizedSubstr = removeAccents(substr)

      const strRegExp = new RegExp(normalizedSubstr, 'gi')
      const matchIndices: Array<{ start: number; end: number }> = []

      let match: RegExpExecArray | null
      while ((match = strRegExp.exec(normalizedStr)) !== null) {
        matchIndices.push({ start: match.index, end: match.index + match[0].length })
      }

      if (matchIndices.length === 0) {
        return str
      }

      let result = ''
      let currentIndex = 0

      for (const { start, end } of matchIndices) {
        result = `${result}${str.slice(currentIndex, start)}`
        result += `<strong>${str.slice(start, end)}</strong>`
        currentIndex = end
      }

      result = `${result}${str.slice(currentIndex)}`

      return <div dangerouslySetInnerHTML={{ __html: result }} />
    }
  }

  return { boldString }
}
